const Error500 = () => {
  return (
    <h1 style={{ color: "red", fontSize: "24px", fontWeight: "bold" }}>
      Something went wrong!!!
    </h1>
  );
};

export default Error500;
